import { render, staticRenderFns } from "./WalletTransactionStatus.vue?vue&type=template&id=1e11e28e&"
import script from "./WalletTransactionStatus.vue?vue&type=script&lang=js&"
export * from "./WalletTransactionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports